import React from "react";
import { Typography } from "@/components/Typography";
import { PreviewCloudinaryImage } from "@/features/previews/shared/components/PreviewCloudinaryImage";
import { logError } from "@/services/DatadogService/DatadogService";

import type { QRProps } from "@/contexts/QREditorContext/types";

interface Mp3ContentInfoProps {
  data: NonNullable<QRProps<"mp3">["data"]>;
}

export const Mp3ContentInfo = ({ data }: Mp3ContentInfoProps) => {
  const handleImageError = (error: string | Event) => {
    const imageError = new Error(`MP3 cover image failed to load: ${error}`);
    logError(imageError, {
      component: "Mp3ContentInfo",
      action: "cover_image_load_failed",
      imageUrl: data?.logoUrl,
    });
  };

  return (
    <>
      {data?.logoUrl && (
        <PreviewCloudinaryImage
          src={data?.logoUrl}
          alt="mp3 cover image"
          className="mp3-template__cover-image"
          onError={handleImageError}
        />
      )}

      {data?.mp3Title && (
        <Typography
          Tag="p"
          classname="u-semibold u-spacing-0 u-spacing-4--top mp3-template__title"
          size="m"
        >
          {data.mp3Title}
        </Typography>
      )}

      {data?.mp3Description && (
        <Typography
          Tag="p"
          classname="mp3-template__description"
        >
          {data.mp3Description}
        </Typography>
      )}
    </>
  );
};
